
const Image = ({id, title, image }) => {
  return (
    <div className="gallery-item" key={`${title}-${id}`}>
      <div className="hover-bg">
        {" "}
        <a href={image} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={image} className="img-responsive" alt={title} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};


const Gallery = (props) => {
  return (
    <div id="gallery" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
        </div>
        <div className="gallery-grid">
          {props.data
            ? props.data.map((d, i) => (
                  <Image
                    id={i}
                    key = {`gallery-${i}`}
                    title={d.title}
                    image={d.image}
                  />
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};

export {Gallery, Image}